import { render, staticRenderFns } from "./SuppliedItemResponsiveCard.vue?vue&type=template&id=240b1a2a"
import script from "./SuppliedItemResponsiveCard.vue?vue&type=script&lang=js"
export * from "./SuppliedItemResponsiveCard.vue?vue&type=script&lang=js"
import style0 from "./SuppliedItemResponsiveCard.vue?vue&type=style&index=0&id=240b1a2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports